'use client'

import {Box, Button, Flex, Heading, SimpleGrid, VStack} from '@chakra-ui/react'
import moment from 'moment'
import "moment/locale/lv"
import "moment/locale/en-gb"
import {findHappeningLater, findHappeningNow} from '../../interfaces/IWeekdayTime'
import {useMemo} from "react";
import {fromSerializable, IMomentDealSerializable} from "../../interfaces/IMomentDeal";
import {BarDetails, BarWithDeals, ChainWithDeals} from "../../interfaces/Bar";
import PageLayout from "../../components/ui/layout";
import BarCard from "../../components/ui/bar";

import 'moment/locale/en-gb';
import 'moment/locale/lv';
import {useLocale, useTranslations} from "next-intl";
import {Link} from "../../i18n/routing";
import {addRegionToLocale} from "../../components/tools/momentLocale";
import {BarOverview} from "../../components/ui/BarOverview";
import ChainCard from "../../components/ui/ChainCard";
import dynamic from "next/dynamic";

const HappeningNowView = dynamic(() => import("../../components/ui/happeningnow"), { ssr: false });
const AdSenseBottomBanner = dynamic(
    () => import("../../components/AdsenseBanner"),
    { ssr: false }
);

interface IProps {
    bars: BarWithDeals[],
    chains: ChainWithDeals[],
    upcomingOrHappening: IMomentDealSerializable[],
    focusBar?: BarWithDeals,
    barDetails?: BarDetails|undefined
}

export default function HomePage({ bars, chains, upcomingOrHappening, focusBar, barDetails }: IProps) {
    const locale = useLocale()
    console.log("Client locale", locale)
    moment.locale(addRegionToLocale(locale))

    const _upcomingOrHappening = useMemo(() => {
        return upcomingOrHappening.map(a => fromSerializable(a))
    }, [upcomingOrHappening])

    const happeningNow = useMemo(() => {
        return findHappeningNow(_upcomingOrHappening)
    }, [_upcomingOrHappening])

    const upcoming = useMemo(() => {
        return findHappeningLater(_upcomingOrHappening)
    }, [_upcomingOrHappening])

    const t = useTranslations("Home")
    const tChain = useTranslations("chain")

    return (
        <Box>
            {
                focusBar ? <BarOverview bar={focusBar} details={barDetails}/> : (
                    <PageLayout city='Riga' happeningNow={happeningNow} upcoming={upcoming}>
                        <Flex w="100%" align="center" direction="column">
                            <VStack m="20px" justifyContent="center" w={{base: "95vw", md: "70vw"}}>
                                {happeningNow && happeningNow.length > 0 && (
                                    <VStack>
                                        <HappeningNowView marginX="0px" happeningNow={[]} upcoming={upcoming}/>
                                    </VStack>
                                )}
                                <Flex align="center" justifyContent="start" marginY="20px" data-nosnippet>
                                    <Heading size="md" mb={0}>{t("allBars")}</Heading>
                                    <Link href={{pathname: "/addbar"}}><Button variant="secondary" marginStart="20px" rel="nofollow">{t("suggestEdit")}</Button></Link>
                                </Flex>
                                <VStack gap={4} align="stretch">
                                    <SimpleGrid gap={4}>
                                        {chains.filter(chain => chain.deals.length >= -1).map(chain => (
                                            <ChainCard chain={chain} bars={bars.filter(b => b.chain?.id == chain.id)} key={chain.id}/>
                                        ))}
                                    </SimpleGrid>
                                    <SimpleGrid gap={4} >
                                        {bars.filter(bar => bar.deals.length > 0 && bar.chain == null).map((bar: BarWithDeals) => (
                                            <BarCard bar={bar} key={bar.name}/>
                                        ))}
                                    </SimpleGrid>
                                </VStack>
                            </VStack>
                        </Flex>
                    </PageLayout>
                )
            }
            <Flex position="fixed" bottom={0} w="100vw" justifyContent="center" alignContent="center">
                <Box borderWidth={1} borderColor={process.env.NODE_ENV === 'development' ? 'red' : 'unset'} h="15vh" w={{base: "100%", md: "90%"}}>
                    <AdSenseBottomBanner/>
                </Box>
            </Flex>
        </Box>
    )
}